import React from 'react';

import ContentCard from '../../components/Common/ContentCard';
import FooterCallToAction from '../../components/PageSections/FooterCallToAction';
import PageSection from '../../components/PageSections/PageSection';

export const ContentfulComponentCallToAction = (section, i, styles) => {
  const backgroundColors = {
    Grey: styles.grey,
    'Dark Blue Circle Pattern': styles.darkBlue,
    White: styles.white,
    'Light Grey': styles.lightGrey,
    'Purple / Pink': styles.purplePink,
    'Purple Gradient': styles.purpleGradient,
    'Multicolor Gradient': styles.multicolorGradient,
  };

  const bgColor = backgroundColors[section.backgroundColor];

  let fullSection = [];

  if (!section.image && !section.attachment) {
    return (
      <PageSection key={i} className={backgroundColors[section.backgroundColor] || styles.white}>
        <FooterCallToAction section={section} />
      </PageSection>
    );
  }
  // TODO: Is this being used?
  fullSection.push(
    <ContentCard
      key={i}
      heading={section.title}
      backgroundStyle={bgColor || styles.white}
      image={section.image}
      copy={section?.description?.description}
      imageBleed={false}
      imageSide={'Right'}
      ctaUrl={section.url || section?.attachment?.file?.url}
      ctaIsDownload={section?.attachment?.file?.url || false}
      ctaLabel={section.ctaLabel}
      newWindow={section.newWindow}
      limitImageHeight
      moderate
    />
  );
  return fullSection;
};
